import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import ReactModal from 'react-modal'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import Form from '../stripe-payment-form/form'

function StripePaymentModal(props) {
  const { currency, amount, appFee, stripe, location, game, player, storeOption, onClose, onPayment, onCardsUpdate } = props
  const accountOptions = stripe.account ? {stripeAccount: stripe.account} : {}
  const stripePromise = loadStripe(stripe.publishable_key, accountOptions)

  return (
    <ReactModal isOpen={true} onRequestClose={onClose} contentLabel='Payment Modal'>
      <div className='shop-manual-payment panel panel-default'>
        <div className='panel-heading'>Create Transaction</div>
        <div className='panel-body stripe-panel'>
          <Elements stripe={stripePromise}>
            <Form
              currency={currency}
              amount={amount}
              appFee={appFee}
              location={location}
              game={game}
              player={player}
              storeOption={storeOption}
              onClose={onClose}
              onPayment={onPayment}
              onCardsUpdate={onCardsUpdate}
            />
          </Elements>
        </div>
      </div>
    </ReactModal>
  )
}

StripePaymentModal.propTypes = {
  amount: PropTypes.number.isRequired,
  appFee: PropTypes.number.isRequired,
  stripe: PropTypes.object.isRequired,
  location: PropTypes.number.isRequired,
  player: PropTypes.number,
  game: PropTypes.number,
  storeOption: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onPayment: PropTypes.func.isRequired,
  onCardsUpdate: PropTypes.func
}

export default StripePaymentModal
